import { render, staticRenderFns } from "./ReferralLeakageAuditLeadsPage.vue?vue&type=template&id=63fa73d2&scoped=true"
import script from "./ReferralLeakageAuditLeadsPage.vue?vue&type=script&lang=js"
export * from "./ReferralLeakageAuditLeadsPage.vue?vue&type=script&lang=js"
import style0 from "./ReferralLeakageAuditLeadsPage.vue?vue&type=style&index=0&id=63fa73d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa73d2",
  null
  
)

export default component.exports